import React, { useState, useEffect} from "react";
import { useIntl, FormattedMessage } from 'react-intl'
import {
	Collapse,
	TextField,
	Grid,
	Box,
} from '@material-ui/core';
import Switch from "react-switch";

const FILTER_STATE_INIT = {
	nombre: '',
	showInactivos: false
}

const MotivosGridFiltros = (props) => {
	const intl = useIntl();
	const [filtersState, setFiltersState] = useState(FILTER_STATE_INIT);

	// Carga inicial: dispara la primera búsqueda al montar
	useEffect(() => {
		props.setFilterQuery({ ...FILTER_STATE_INIT });
	}, []);

	useEffect(() => {
		!props.dropdownActive && props.setFilterResetInputs(false)
	}, [props.dropdownActive]);

	useEffect(() => {
		if (props.filterResetInputs) {
			setFiltersState(FILTER_STATE_INIT);
		}
	}, [props.filterResetInputs]);

	const triggerSearch = (state) => {
		props.handleFilterChange();
		props.setSearchActive(state.nombre !== '');
		props.setFilterQuery({ ...state });
	};

	const handleBuscar = () => {
		triggerSearch(filtersState);
	};

	const handleChangeInactivosSwich = (value) => {
		const updated = { ...filtersState, showInactivos: value };
		setFiltersState(updated);
		triggerSearch(updated);
	};

	const handleOnEnter = (e) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			triggerSearch(filtersState);
		}
	};

	return (
		<>
			<Collapse in={props.dropdownActive}>
				<Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }} alignItems="flex-end">
					<Grid component={Box} item xs={3}>
						<form noValidate autoComplete="off">
							<TextField
								label={intl.formatMessage({ id: "Motivo", defaultMessage: "Motivo" })}
								placeholder={intl.formatMessage({ id: "Motivo", defaultMessage: "Motivo" })}
								name="nombre"
								value={filtersState.nombre}
								onChange={(e) => setFiltersState({ ...filtersState, nombre: e.target.value })}
								onKeyDown={(e) => handleOnEnter(e)}
								className="col-12"
							/>
						</form>
					</Grid>
				</Grid>
				<Grid container item xs={12} spacing={2} alignItems="center" style={{ marginBottom: 20 }}>
					<Grid component={Box} item xs="auto" style={{ paddingRight: 20 }}>
						<div className="d-flex align-items-center" style={{ gap: 8 }}>
							<FormattedMessage
								id="formulariosGridFilters.render.filtros.ver_inactivos"
								defaultMessage="Ver Inactivos"
							/>
							<Switch
								onChange={(value) => handleChangeInactivosSwich(value)}
								checked={filtersState.showInactivos}
								offColor="#FF4961"
								onColor="#28D094"
							/>
						</div>
					</Grid>
					<Grid component={Box} item style={{ flex: 1 }} />
					<Grid component={Box} item xs="auto">
						<button
							className="btn btn-primary"
							onClick={handleBuscar}
						>
							<i className="fa fa-search fa-xs"></i> <FormattedMessage id="Buscar" defaultMessage="Buscar" />
						</button>
					</Grid>
				</Grid>
			</Collapse>
		</>
	)
}

export default MotivosGridFiltros
